import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { authSlice } from './features/auth/auth.slice';
import { consultaSlice } from './features/consulta/consulta.slice';
import { creditSlice } from './features/credit/credit.slice';
import { paymentSlice } from './features/payment/payment.slice';
import { batchSlice } from './features/batch/batch.slice';
import { userSlice } from './features/user/user.slice';
import { apiKeySlice } from './features/apiKey/apiKey.slice';
import { dashboardSlice } from './features/dashboard/dashboard.slice';
import { indicatorSlice } from './features/indicator/indicator.slice';
import { integrationSlice } from './features/integration/integration.slice';
import { leilaoSlice } from './features/leilao/leilao.slice';
import { liveLeadSlice } from './features/liveLead/liveLead.slice';

export const store = configureStore({
	reducer: combineReducers({
		auth: authSlice.reducer,
		consulta: consultaSlice.reducer,
		credit: creditSlice.reducer,
		payment: paymentSlice.reducer,
		batch: batchSlice.reducer,
		user: userSlice.reducer,
		apiKey: apiKeySlice.reducer,
		dashboard: dashboardSlice.reducer,
		indicator: indicatorSlice.reducer,
		integration: integrationSlice.reducer,
		leilao: leilaoSlice.reducer,
		liveLead: liveLeadSlice.reducer
	}),
	middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
